<template>
  <div class="page">
    <!-- 统一风格页头 -->
    <div class="page-header">
      <div class="header-left">
        <h1 class="page-title">卡系列</h1>
      </div>
      <div class="header-right">
        <el-button size="mini" type="warning" @click="onAddButton" class="btn-add">新增</el-button>
      </div>
    </div>

    <div class="layout">
      <!-- 统一风格搜索区 -->
      <div class="search-card">
        <div class="search-row">
          <el-input
              v-model="listQuery.nameLike"
              placeholder="名稱"
              prefix-icon="el-icon-search"
          ></el-input>

          <div class="search-buttons">
            <el-button size="small" type="warning" @click="onSearch" icon="el-icon-search">搜尋</el-button>
            <el-button size="small" @click="onReset" icon="el-icon-refresh">重置</el-button>
          </div>
        </div>
      </div>

      <!-- PC端表格 -->
      <div class="table-container">
        <div class="pc-table">
          <el-table
              @sort-change="handleSortChange"
              :data="tableData"
              style="width:100%"
              border
              stripe
              size="small"
              empty-text="暫無數據"
          >
            <el-table-column label="#" type="index" width="50" align="center"></el-table-column>

            <el-table-column prop="image" label="背景圖片" align="center" min-width="120">
              <template slot-scope="{ row }">
                <el-image
                    v-if="row.image"
                    :src="row.image"
                    fit="cover"
                    style="width:40px;height:40px;border-radius:4px"
                ></el-image>
                <span v-else>-</span>
              </template>
            </el-table-column>

            <el-table-column prop="name" label="名稱" align="center" sortable="custom" min-width="120"></el-table-column>
            <el-table-column prop="status" label="狀態" align="center" sortable="custom" min-width="120">
              <template slot-scope="{ row }">
                <el-tag
                    :type="row.status === 0 ? 'info' : 'success'"
                    disable-transitions>{{ row.status | formatStatus }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="startTime" label="開始時間" align="center" sortable="custom" min-width="160">
              <template slot-scope="{ row }">
                <span>{{ row.startTime | formatDateTime }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="endTime" label="結束時間" align="center" sortable="custom" min-width="160">
              <template slot-scope="{ row }">
                <span>{{ row.endTime | formatDateTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="onEditButton(scope.row)" icon="el-icon-edit">編輯</el-button>
                <el-button type="text" size="small" @click="onDeleteButton(scope.row.id)" icon="el-icon-delete">刪除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <!-- 分页 -->
    <div class="pagination-wrap">
      <Pagination
          v-show="total > 0"
          :total="total"
          :page.sync="listQuery._page"
          :limit.sync="listQuery._limit"
          @pagination="getCardTitle"
      />
    </div>

    <!-- 新增弹窗 -->
    <el-dialog
        title="新增卡系列"
        :visible.sync="addDialogVisible"
        width="600px"
        append-to-body
        close-on-click-modal
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="80px" size="small">
        <el-form-item label="名稱" prop="name">
          <el-input v-model="form.name" placeholder="請輸入名稱"></el-input>
        </el-form-item>
        <el-form-item label="狀態" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">上架</el-radio>
            <el-radio :label="0">下架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="開始日期" prop="startTime">
          <el-date-picker
              v-model="form.startTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="請選擇開始日期"
              @change="() => $refs.form.validateField('endTime')"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="結束日期" prop="endTime">
          <el-date-picker
              v-model="form.endTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="請選擇結束日期"
              :picker-options="endPickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="背景圖片">
          <upload @childByValue="childByValue" :isImgUpload="true" :imageurl="form.image" buttonText="瀏覽"></upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeAddDialog">取 消</el-button>
        <el-button type="primary" @click="submitAddForm">確 認 新 增</el-button>
      </div>
    </el-dialog>

    <!-- 编辑弹窗 -->
    <el-dialog
        title="編輯卡系列"
        :visible.sync="editDialogVisible"
        width="600px"
        append-to-body
        close-on-click-modal
    >
      <el-form ref="editForm" :model="editForm" :rules="rules" label-width="80px" size="small">
        <el-form-item label="名稱" prop="name">
          <el-input v-model="editForm.name" placeholder="請輸入名稱"></el-input>
        </el-form-item>
        <el-form-item label="狀態" prop="status">
          <el-radio-group v-model="editForm.status">
            <el-radio :label="1">上架</el-radio>
            <el-radio :label="0">下架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="開始日期" prop="startTime">
          <el-date-picker
              v-model="editForm.startTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="請選擇開始日期"
              @change="() => $refs.editForm.validateField('endTime')"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="結束日期" prop="endTime">
          <el-date-picker
              v-model="editForm.endTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="請選擇結束日期"
              :picker-options="endPickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="背景圖片">
          <upload @childByValue="editChildByValue" :isImgUpload="true" :imageurl="editForm.image" buttonText="瀏覽"></upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeEditDialog">取 消</el-button>
        <el-button type="primary" @click="submitEditForm">保 存 修 改</el-button>
      </div>
    </el-dialog>

    <!-- 删除确认弹窗 -->
    <el-dialog title="提示" :visible.sync="centerDialogVisible" width="300px">
      <p>確定刪除該條數據？</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmFunction">確 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { getCardTitleList, updateCardTitle, saveCardTitle } from "@/api/setting";
import upload from "@/components/upload";

export default {
  components: { Pagination, upload },
  data() {
    return {
      total: 0,
      staffId: null,
      centerDialogVisible: false,
      addDialogVisible: false,
      editDialogVisible: false,
      currentId: null,
      listQuery: {
        nameLike: null,
        orderBy: null,
        _page: 1,
        _limit: 10,
      },
      form: {
        name: '',
        status: 0,
        startTime: '',
        endTime: '',
        image: '',
      },
      editForm: {
        name: '',
        status: 0,
        startTime: '',
        endTime: '',
        image: '',
      },
      rules: {
        name: [{ required: true, message: '請輸入名稱', trigger: 'blur' }],
        startTime: [{ required: true, message: '請選擇開始日期', trigger: 'change' }],
        endTime: [
          { required: true, message: '請選擇結束日期', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              let startVal = '';
              if (this.addDialogVisible) {
                startVal = this.form.startTime;
              } else if (this.editDialogVisible) {
                startVal = this.editForm.startTime;
              }
              if (!startVal) {
                callback(new Error('請先選擇開始日期'));
                return;
              }
              if (new Date(value) <= new Date(startVal)) {
                callback(new Error('結束時間必須大於開始時間'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ]
      },
      tableData: [],
    };
  },
  computed: {
    endPickerOptions() {
      let startVal = '';
      if (this.addDialogVisible) {
        startVal = this.form.startTime;
      } else if (this.editDialogVisible) {
        startVal = this.editForm.startTime;
      }
      return {
        disabledDate: (time) => {
          if (!startVal) return false;
          return time.getTime() < new Date(startVal).getTime();
        }
      };
    }
  },
  filters: {
    formatStatus(v) {
      return v === 0 ? "下架" : "上架";
    },
    formatDateTime(time) {
      let timeStr = ''
      // 适配后端DateTime对象
      if(time && typeof time === 'object' && time.date){
        timeStr = time.date
      }else{
        timeStr = time
      }
      if (!timeStr) return "-";
      const d = new Date(timeStr);
      if (isNaN(d.getTime())) return "-";
      const year = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const h = String(d.getHours()).padStart(2, "0");
      const min = String(d.getMinutes()).padStart(2, "0");
      const s = String(d.getSeconds()).padStart(2, "0");
      return `${year}-${m}-${day} ${h}:${min}:${s}`;
    }
  },
  created() {
    this.getCardTitle();
  },
  methods: {
    childByValue(v) {
      this.form.image = v;
    },
    editChildByValue(v) {
      this.editForm.image = v;
    },

    // 新增
    onAddButton() {
      this.addDialogVisible = true;
    },
    closeAddDialog() {
      this.addDialogVisible = false;
      this.$nextTick(() => {
        this.form = { name: '', status: 0, startTime: '', endTime: '', image: '' };
        this.$refs.form?.clearValidate();
      });
    },
    submitAddForm() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        saveCardTitle(this.form).then(() => {
          this.$message.success('新增成功');
          this.closeAddDialog();
          this.getCardTitle();
        }).catch(() => {
          this.$message.error('新增失敗');
        });
      });
    },

    // 编辑
    onEditButton(row) {
      this.currentId = row.id;
      const getTimeStr = (val) => {
        if(!val) return ''
        if(typeof val === 'object' && val.date){
          return val.date.slice(0,19)
        }
        return val
      }
      this.editForm = {
        name: row.name || '',
        status: row.status ?? 0,
        startTime: getTimeStr(row.startTime),
        endTime: getTimeStr(row.endTime),
        image: row.image || '',
      };
      this.editDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.editForm.clearValidate();
      });
    },
    closeEditDialog() {
      this.editDialogVisible = false;
      this.currentId = null;
      this.$nextTick(() => {
        this.$refs.editForm?.clearValidate();
      });
    },
    submitEditForm() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return;
        updateCardTitle(this.currentId, this.editForm).then(() => {
          this.$message.success('修改成功');
          this.closeEditDialog();
          this.getCardTitle();
        }).catch(() => {
          this.$message.error('修改失敗');
        });
      });
    },

    // 排序搜索分页
    handleSortChange(col) {
      this.listQuery.orderBy = col.order ? `${col.prop} ${col.order === "descending" ? "desc" : "asc"}` : null;
      this.listQuery._page = 1;
      this.getCardTitle();
    },
    onSearch() {
      this.listQuery._page = 1;
      this.getCardTitle();
    },
    onReset() {
      Object.keys(this.listQuery).forEach(k => {
        this.listQuery[k] = null;
        if (k === "_page") this.listQuery[k] = 1;
        if (k === "_limit") this.listQuery[k] = 10;
      });
      this.getCardTitle();
    },

    // 删除弹窗确认
    onDeleteButton(id) {
      this.staffId = id;
      this.centerDialogVisible = true;
    },
    confirmFunction() {
      // TODO：接入删除接口
      this.centerDialogVisible = false;
      this.getCardTitle();
      this.$message.success('刪除成功');
    },

    getCardTitle() {
      const params = { ...this.listQuery, _page: this.listQuery._page - 1 };
      Object.keys(params).forEach(key => {
        if (params[key] == null) delete params[key];
      });
      getCardTitleList(params).then(v => {
        this.tableData = v.data || [];
        this.total = +v.headers["x-total-count"] || 0;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  padding: 16px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
  padding-bottom: 12px;
  border-bottom: 1px solid #e4e7ed;

  .page-title {
    font-size: 20px;
    font-weight: 600;
    color: #B62D2E;
    margin: 0;
  }
}

.layout {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 16px;
}

.search-card {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 6px;
  margin-bottom: 20px;

  .search-row {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    align-items: center;

    .el-input, .el-select {
      flex: 1;
      min-width: 160px;
    }

    .search-buttons {
      display: flex;
      gap: 8px;
    }
  }
}

.table-container {
  width: 100%;
}

.pagination-wrap {
  text-align: center;
  padding: 10px 0;
}

.dialog-footer {
  text-align: right;
}

@media (max-width: 768px) {
  .page { padding: 8px; }
  .layout { padding: 12px; }
  .search-row { flex-direction: column; align-items: stretch; }
  .pc-table { display: none; }
}
.el-image__error, .el-image__inner, .el-image__placeholder {
  width: 45%;
}
</style>